// Local "today attendance" snapshot to avoid slow UI updates while waiting for API.
// This is a best-effort cache; server data remains the source of truth.

const STORAGE_PREFIX = 'chamcong_today_attendance_';

const pad2 = (n) => String(n).padStart(2, '0');

export const getLocalDateKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const resolveEmployeeIdentityKey = (employee) => {
  if (!employee) return '';
  const code = String(employee.code || '').trim();
  if (code) return `code_${code.toLowerCase()}`;
  const id = employee.id ?? employee.employee_id ?? employee.employeeId ?? '';
  if (id === null || id === undefined || id === '') return '';
  return `id_${String(id).trim()}`;
};

export const readLocalTodayAttendance = (employee) => {
  try {
    const identity = resolveEmployeeIdentityKey(employee);
    if (!identity) return null;

    const raw = localStorage.getItem(STORAGE_PREFIX + identity);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const todayKey = getLocalDateKey();
    if (parsed.date !== todayKey) return null;

    return {
      checkin_time: parsed.checkin_time || null,
      checkout_time: parsed.checkout_time || null,
      work_hours: typeof parsed.work_hours === 'number' ? parsed.work_hours : 0,
    };
  } catch {
    return null;
  }
};

export const writeLocalTodayAttendance = (employee, attendance) => {
  try {
    const identity = resolveEmployeeIdentityKey(employee);
    if (!identity) return;

    const payload = {
      date: getLocalDateKey(),
      checkin_time: attendance?.checkin_time || null,
      checkout_time: attendance?.checkout_time || null,
      work_hours: typeof attendance?.work_hours === 'number' ? attendance.work_hours : 0,
    };
    localStorage.setItem(STORAGE_PREFIX + identity, JSON.stringify(payload));
  } catch {
    // ignore localStorage errors
  }
};

